import { connect } from 'react-redux';

import * as R from 'ramda';
import { fetchNotifications } from 'notifications/store/NotificationSlice';
import Notifications from './Notifications';

const mapState = R.applySpec({
  notifications: R.path(['notifications', 'notifications']),
});

const mapDispatchToProps = {
  fetchNotifications,
};

export default connect(mapState, mapDispatchToProps)(Notifications);
